import { type ComboboxItem, type OptionsFilter } from '@mantine/core';

export const defaultOptionsFilter: OptionsFilter = ({ options, search }) => {
    const valueLower = search.toLocaleLowerCase();

    return (options as ComboboxItem[]).filter(
        (option) => option.label.toLocaleLowerCase().includes(valueLower) || option.value.includes(valueLower),
    );
};
